import axiosInterceptor from '../../interceptor/axiosClient';

export const verifyEmail = async (uidb64: string) => {
  const response = await axiosInterceptor.get(`verify-email/?uidb64=${uidb64}`);

  return response;
};
